import { render, staticRenderFns } from "./OutstandingBalanceReport.vue?vue&type=template&id=155f405a&"
import script from "./OutstandingBalanceReport.vue?vue&type=script&lang=js&"
export * from "./OutstandingBalanceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports